export default __webpack_public_path__ + "static/pa-61217fc9545f5b67816f572ababdcc74.svg";